import React from 'react';

const TextInput = ({inputDisabled, onKeyUp, submit, ...props}) => {

  return (
    <div className="text-input flex md:flex-wrap items-center gap-2 p-4">
      <input type="text" className="flex-1 bg-white/10 p-4 border-1 rounded-[50px]" id="chat-input" disabled={inputDisabled} placeholder="Type your message..." onKeyUp={onKeyUp} />
      <button className="bg-red text-white w-[61px] h-[61px] rounded-full flex justify-center content-center aspect-1" onClick={() => submit(document.getElementById('chat-input'))}><img className="w-[20px]" src="/modules/custom/ie_chatbot/assets/send-icon.svg" /></button>
    </div>
  );

};

export default TextInput;
